<h2>
  {{ translationService.getProvincialRecyclabilityText() }}
</h2>
@if (provincialRecyclability.length) {
  <mat-nav-list>
    @for (
      recyclability of provincialRecyclability;
      track recyclability;
      let i = $index;
      let last = $last
    ) {
      <a
        mat-list-item
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
      >
        <span matListItemTitle>
          <span class="bold">{{ recyclability.province }}:</span>
          {{ recyclability.recyclabilityStatus }}
        </span>
      </a>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
} @else {
  <span>{{ translationService.getNaText() }}</span>
}
